export enum ACTION {
  NEW_LICENSE = "NEW",
  EDIT_LICENSE = "EDIT",
  DELETE_LICENSE = "DELETE",
}
